/* ŠTART 90 LP behaviours — ported from hitpromo v10 */
(function () {
  var root = document.getElementById('hit-start');
  if (!root) return;

  var mediaAssets = window.IPROBIO_START90_MEDIA || {};
(function(){
  // reveal on scroll
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12});
  root.querySelectorAll('[data-reveal]').forEach(function(el){io.observe(el)});

  // floating buy pill: visible only while no real order button is on screen.
  // It hands off to EVERY in-content CTA, not just the hero one — the pill fades out as a
  // section's own button arrives and materialises again once that button has scrolled away.
  var fab=document.getElementById('floatingCta');
  // shop footer is tall; scope to layout footer so we don't pick an unrelated <footer>
  var foot=document.querySelector('.s90-shell .site-ft') || document.querySelector('#hit-start ~ footer, .content + footer, footer');
  if(fab){
    // the persistent nav button is excluded (it never leaves the sticky header, so the pill
    // could never appear on desktop), as are buttons inside modals
    var ctas=[].filter.call(root.querySelectorAll('.btn-buy'), function(el){
      return el!==fab && !el.classList.contains('nav-cta') && !el.classList.contains('floating-cta') && !el.closest('dialog');
    });
    var fabOn=false, fabTick=false;
    function fabState(){
      fabTick=false;
      // the pill's own slot is the handoff line: once a real button has risen this far it has taken
      // the pill's place, so the pill goes. The pill itself never moves or resizes — the only thing
      // that ever changes is whether it is there, which is what keeps the changeover clean.
      var fabRect=fab.getBoundingClientRect();
      var line=fabRect.top;
      // A button only takes the pill's place once it is genuinely on screen: at least half of it
      // showing above the pill's line. A sliver clinging to the top edge is not something anyone
      // can click, and treating it as a takeover left the user with no order button at all right
      // after they clicked one. The hysteresis band keeps the threshold itself from flickering.
      // the usable area starts under the sticky header — a button tucked behind it is not
      // something anyone can click, so it must not count as being on screen
      var hd=document.querySelector('.s90-shell .site-hd') || document.querySelector('.hit-site-header-sticky');
      var topEdge=hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0;
      var taken=false;
      for(var i=0;i<ctas.length;i++){
        var r=ctas[i].getBoundingClientRect();
        if(!r.width || !r.height) continue;
        var seen=Math.min(r.bottom,line)-Math.max(r.top,topEdge);
        // hysteresis band: while the pill is up a button has to be clearly there (60%) to displace
        // it, and once displaced it has to drop well out of sight (40%) to give the pill back.
        // The two thresholds must straddle, or the state flips on every frame inside the band.
        if(seen>=r.height*(fabOn?0.6:0.4)){taken=true;break}
      }
      // Hide only when the shop footer actually overlaps the pill slot — vh*0.9 was too eager
      // with the taller Venalio footer and made the sticky disappear mid-page.
      var atFoot=foot ? foot.getBoundingClientRect().top < fabRect.bottom + 8 : false;
      var shown=!taken && !atFoot;
      if(shown!==fabOn){fabOn=shown;fab.classList.toggle('show',shown)}
    }
    function fabQueue(){if(!fabTick){fabTick=true;requestAnimationFrame(fabState)}}
    window.addEventListener('scroll',fabQueue,{passive:true});
    window.addEventListener('resize',fabQueue,{passive:true});
    fabState();
  }


  // research modal: staggered reveals, timeline draw, scrollspy
  var rmDone=false;
  function rmAnimate(){
    if(rmDone) return; rmDone=true;
    var root=rmm.querySelector('.rm-scroll');
    var groups=[['.rm-section',0],['.rm-thesis__step',60],['.rm-method',55],['.rm-ladder__step',55],['.rm-product',90],['.rm-sources li',26]];
    groups.forEach(function(g){
      rmm.querySelectorAll(g[0]).forEach(function(el,n){
        el.classList.add('rm-anim');
        el.style.setProperty('--d',(n*g[1])+'ms');
      });
    });
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target) } });
    },{root:root,threshold:.08,rootMargin:'0px 0px -6% 0px'});
    rmm.querySelectorAll('.rm-anim,.rm-timeline,.rm-era').forEach(function(el){io.observe(el)});
    rmm.querySelectorAll('.rm-era').forEach(function(el,n){el.style.setProperty('--d',(n*90)+'ms')});

    var links=[].slice.call(rmm.querySelectorAll('.rm-jumps a'));
    var spy=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        links.forEach(function(a){a.classList.toggle('on',a.getAttribute('href')==='#'+e.target.id)});
      });
    },{root:root,threshold:.02,rootMargin:'-12% 0px -70% 0px'});
    rmm.querySelectorAll('.rm-section[id]').forEach(function(s){spy.observe(s)});
  }
  // 40+ years research-lineage modal
  var rmm=document.getElementById('researchModal'), rmTrigger=null;
  if(rmm){
    root.querySelectorAll('[data-research-open]').forEach(function(b){b.addEventListener('click',function(){
      rmTrigger=b;
      rmm.showModal();
      rmAnimate();
    })});
    rmm.querySelectorAll('[data-research-close]').forEach(function(c){c.addEventListener('click',function(){
      if(c.matches('a[href^="#"]'))rmTrigger=null;
      rmm.close();
    })});
    rmm.addEventListener('click',function(e){if(e.target===rmm)rmm.close()});
    rmm.addEventListener('keydown',function(e){if(e.key==='Escape' && rmm.open){e.preventDefault();rmm.close()}});
    rmm.addEventListener('close',function(){if(rmTrigger){rmTrigger.focus();rmTrigger=null}});
  }

  // gift modal (why together)
  var gm=document.getElementById('giftModal');
  root.querySelectorAll('[data-gift]').forEach(function(b){b.addEventListener('click',function(){gm.showModal()})});
  gm.querySelectorAll('[data-gift-close]').forEach(function(c){c.addEventListener('click',function(){gm.close()})});
  gm.addEventListener('click',function(e){if(e.target===gm)gm.close()});

  // guarantee modal (money-back detail)

  // hero → scroll to Facebook reviews
  var rv=document.getElementById('reviews');

  // single-open FAQ
  var qas=root.querySelectorAll('.qa');
  qas.forEach(function(d){d.querySelector('summary').addEventListener('click',function(){
    qas.forEach(function(o){if(o!==d)o.removeAttribute('open')});
  })});
})();


/* Rolling media strip + in-page article popup (resizable / fullscreen / closable). */
(function(){
  var RL=[
    {f:'forbes.png',a:'Forbes',u:'https://www.forbes.sk/vyrabaju-bakterie-na-mieru-kysucania-dobyjaju-rastuci-trh-s-probiotikami/',e:false},
    {f:'pravda.png',a:'Pravda',u:'https://zdravie.pravda.sk/zdravie-a-prevencia/clanok/586509-odbornici-creva-produkuju-80-hormonu-dobrej-nalady/',e:true},
    {f:'joj24.png',a:'JOJ 24',u:'https://joj24.noviny.sk/rozhovory-joj24/1188512-rozhovory-24-crevny-mikrobiom-a-dlhovekost',e:false},
    {f:'tv360.png',a:'360tka',u:'https://360tka.sk/videos/expert-na-crevny-mikrobiom-m-haranta-za-nutkavou-chutou-na-sladke-mozu-byt-bakterie-vieme-si-ich-ale-podrobit',e:false},
    {f:'ta3.svg',a:'TA3',u:'https://www.ta3.com/relacia/938137/jedalnicek-od-umelej-inteligencie-ako-vlastne-bude-fungovat',e:false},
    {f:'markiza.svg',a:'Tele\u0072\u00e1no (TV Mark\u00edza)',u:'https://www.youtube.com/watch?v=bBy8gb_AIio',e:false},
    {f:'stvr.png',a:'STVR',u:'https://slovensko.stvr.sk/clanky/zdravie/364736/novinky-medzi-probiotikami',e:false},
    {f:'sme.png',a:'SME',u:'https://primar.sme.sk/c/22602491/slovenski-vedci-vyvinuli-personalizovane-probiotika.html',e:false},
    {f:'tasr.png',a:'TASR',u:'https://www.teraz.sk/slovensko/slovenski-vedci-vyvinuli-personalizovan/529847-clanok.html',e:true},
    {f:'sita.svg',a:'SITA',u:'https://sita.sk/vzdravotnictve/crevo-centrum-imunity-pricinu-chronickych-ochoreni-hladajte-v-pokazenom-mikrobiome-rozhovor/',e:false},
    {f:'startitup.svg',a:'Startitup',u:'https://www.startitup.sk/slovaci-vymysleli-ako-nakrmit-tvoj-druhy-mozog-vyrobia-probiotika-tvojmu-crevu-na-mieru/',e:false},
    {f:'postoj.svg',a:'Postoj',u:'https://www.postoj.sk/150042/v-crevach-sa-zacina-aj-dobra-nalada-nestaci-vsak-len-kysla-kapusta-a-bryndza',e:true},
    {f:'vedanadosah.png',a:'Veda na dosah (CVTI SR)',u:'https://vedanadosah.cvtisr.sk/zdravie/vyvoj-biotechnologii-je-beh-na-dlhe-trate-navyse-kapitalovo-velmi-narocny-hovori-martin-haranta/',e:true},
    {f:'zilinskyvecernik.svg',a:'Žilinský večerník',u:'https://www.zilinskyvecernik.sk/clanok/rozhovor-alojz-bomba-probiotika-naozaj-funguju-ale-musia-byt-spravne-vybrate-a-kvalitne/14422/',e:true}
  ];
  var track=document.getElementById('rlTrack'); if(!track) return;
  function mk(it){
    var a=document.createElement('a');
    a.className='rl-logo'; a.href=it.u; a.target='_blank'; a.rel='noopener';
    a.setAttribute('data-embed',it.e?'1':'0'); a.setAttribute('data-outlet',it.a); a.setAttribute('data-file',it.f);
    a.title=it.a+' — číst článek';
    var img=document.createElement('img'); img.src=mediaAssets[it.f]; img.alt=it.a; img.loading='eager'; img.decoding='async';
    a.appendChild(img); return a;
  }
  RL.concat(RL).forEach(function(it){ track.appendChild(mk(it)); });   /* x2 for seamless loop */

  /* Marquee driven by requestAnimationFrame writing the transform each frame. Robust against the
     "frozen until a repaint is forced" behaviour the CSS %-transform animation hit (main-thread
     starvation by the hero canvas) — an rAF loop always advances, so it never freezes. Pauses on
     hover/focus and respects reduced-motion. */
  var mask=track.parentElement, mq=window.matchMedia?matchMedia('(prefers-reduced-motion: reduce)'):{matches:false};
  var SPEED=65, mx=0, period=0, lastTs=0, paused=false, rafId=0, vel=SPEED, dragging=false, justDragged=false, FLING_EASE=2.5, inView=false;
  function measure(){ var gap=parseFloat(getComputedStyle(track).columnGap)||0; period=(track.scrollWidth+gap)/2; }
  function frame(ts){
    var dt = lastTs ? Math.min(48, ts-lastTs) : 16; lastTs=ts;
    if(!dragging && !paused && period>10){ vel += (SPEED-vel)*Math.min(1, dt/1000*FLING_EASE); mx += vel*dt/1000; mx=((mx%period)+period)%period; }
    if(period>10) track.style.transform='translateX('+(-mx).toFixed(2)+'px)';
    rafId=requestAnimationFrame(frame);
  }
  function syncMarquee(){
    if(mq.matches || !inView || document.hidden){
      if(rafId){cancelAnimationFrame(rafId);rafId=0;}
      lastTs=0;
      if(mq.matches) track.style.transform='';
      return;
    }
    if(!rafId){ lastTs=0; rafId=requestAnimationFrame(frame); }
  }
  function startMarquee(){ measure(); syncMarquee(); }
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(entries){ inView=entries[0].isIntersecting; syncMarquee(); }).observe(mask);
  } else { inView=true; }
  document.addEventListener('visibilitychange', syncMarquee);
  startMarquee();
  window.addEventListener('load', measure);
  (function(){ var imgs=track.querySelectorAll('img'), n=imgs.length; if(!n) return;
    function tick(){ if(--n<=0) measure(); }
    imgs.forEach(function(im){ im.complete ? tick() : im.addEventListener('load',tick,{once:true}); }); })();
  var rzt, stripWidth=window.innerWidth; window.addEventListener('resize', function(){ if(stripWidth===window.innerWidth) return; stripWidth=window.innerWidth; clearTimeout(rzt); rzt=setTimeout(measure,200); }, {passive:true});
  if(!window.matchMedia || matchMedia('(hover: hover)').matches){
    mask.addEventListener('mouseenter', function(){ paused=true; });
    mask.addEventListener('mouseleave', function(){ paused=false; });
  }
  mask.addEventListener('focusin', function(){ paused=true; });
  mask.addEventListener('focusout', function(){ paused=false; });
  /* Mobile: a finger on the strip stops it and drags it; a swipe flings it (momentum eases back to auto-scroll). */
  (function(){
    var sx,sy,smx,lx,lt,fv,committed;
    mask.addEventListener('touchstart', function(e){
      if(!e.touches||e.touches.length!==1||period<=10) return;
      var t=e.touches[0]; dragging=true; committed=false; justDragged=false;
      sx=lx=t.clientX; sy=t.clientY; smx=mx; lt=(e.timeStamp||Date.now()); fv=0;
    }, {passive:true});
    mask.addEventListener('touchmove', function(e){
      if(!dragging) return;
      var t=e.touches[0], x=t.clientX, y=t.clientY, dx=x-sx, dy=y-sy;
      if(!committed){
        if(Math.abs(dx)<6 && Math.abs(dy)<6) return;
        if(Math.abs(dy)>Math.abs(dx)){ dragging=false; return; }   /* vertical -> let the page scroll */
        committed=true; sx=x; smx=mx;
      }
      dx=x-sx; mx=((smx-dx)%period+period)%period;
      var now=(e.timeStamp||Date.now()), dtt=now-lt; if(dtt>0) fv=(x-lx)/dtt*1000;
      lx=x; lt=now; justDragged=true;
      if(e.cancelable) e.preventDefault();
    }, {passive:false});
    function end(){ if(!dragging) return; dragging=false;
      if(committed){ vel=Math.max(-1200, Math.min(1200, -fv)); setTimeout(function(){ justDragged=false; }, 80); } }
    mask.addEventListener('touchend', end, {passive:true});
    mask.addEventListener('touchcancel', function(){ if(dragging){ dragging=false; vel=SPEED; } }, {passive:true});
  })();
  if(mq.addEventListener) mq.addEventListener('change', startMarquee);


  var ov=document.getElementById('rlOverlay'),md=document.getElementById('rlModal'),fr=document.getElementById('rlFrame'),
      ti=document.getElementById('rlTitle'),ob=document.getElementById('rlOpen'),fbtn=document.getElementById('rlFull'),
      ftx=document.getElementById('rlFullTxt'),cb=document.getElementById('rlClose'),fb=document.getElementById('rlFallback'),
      fbN=document.getElementById('rlFbName'),fbL=document.getElementById('rlFbLogo'),fbO=document.getElementById('rlFbOpen'),last=null;
  /* Robust cross-device scroll lock: position:fixed + restore. body overflow:hidden is
     unreliable on iOS Safari (can fail to re-enable scroll on close -> page frozen). */
  var _scrollY=0;
  function lockScroll(){ _scrollY=window.scrollY||window.pageYOffset||0; var b=document.body.style;
    b.position='fixed'; b.top=(-_scrollY)+'px'; b.left='0'; b.right='0'; b.width='100%'; }
  function unlockScroll(){ var b=document.body.style;
    b.position=''; b.top=''; b.left=''; b.right=''; b.width=''; window.scrollTo(0,_scrollY); }
  function openModal(it,trig){
    last=trig||null; ti.textContent=it.a; ob.href=it.u; fbO.href=it.u;
    if(it.e){ fb.classList.remove('show'); fr.style.display='block'; fr.src=it.u; }
    else { fr.style.display='none'; fr.removeAttribute('src'); fbN.textContent=it.a; fbL.src=mediaAssets[it.f]; fbL.alt=it.a; fb.classList.add('show'); }
    ov.classList.add('open'); lockScroll();
    (it.e?cb:fbO).focus(); document.addEventListener('keydown',onKey);
  }
  function closeModal(){
    ov.classList.remove('open'); md.classList.remove('is-full'); fbtn.setAttribute('aria-pressed','false'); ftx.textContent='Celá obrazovka';
    fr.removeAttribute('src'); fb.classList.remove('show'); unlockScroll();
    document.removeEventListener('keydown',onKey); if(last&&last.focus){ last.focus(); paused=false; }
  }
  function onKey(e){
    if(e.key==='Escape'){ closeModal(); return; }
    if(e.key==='Tab'){
      var f=[].slice.call(md.querySelectorAll('a[href],button')).filter(function(x){return x.offsetParent!==null;});
      if(!f.length) return; var a=f[0],z=f[f.length-1];
      if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus();}
      else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus();}
    }
  }
  track.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('.rl-logo'); if(!a) return; e.preventDefault(); if(justDragged) return;
    openModal({a:a.getAttribute('data-outlet'),u:a.href,e:a.getAttribute('data-embed')==='1',f:a.getAttribute('data-file')},a);
  });
  fbtn.addEventListener('click',function(){ var on=md.classList.toggle('is-full'); fbtn.setAttribute('aria-pressed',on?'true':'false'); ftx.textContent=on?'Zmenšit':'Celá obrazovka'; });
  cb.addEventListener('click',closeModal);
  ov.addEventListener('click',function(e){ if(e.target===ov) closeModal(); });
})();

})();
